import React from 'react';
import { Link } from 'react-router-dom';

const NotFound: React.FC = () => {
  return (
    <main className="min-h-screen bg-white flex items-center justify-center px-4">
      <div className="text-center max-w-2xl mx-auto">
        {/* 404 Illustration */}
        <div className="mb-8">
          <div className="text-8xl sm:text-9xl font-bold text-brand-blue opacity-20 mb-4">
            404
          </div>
          <div className="w-32 h-32 mx-auto mb-6">
            <svg className="w-full h-full text-brand-orange" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M9.172 16.172a4 4 0 015.656 0M9 12h6m-6-4h6m2 5.291A7.962 7.962 0 0112 15c-2.34 0-4.29-1.009-5.824-2.709M15 6.291A7.962 7.962 0 0012 5c-2.34 0-4.29 1.009-5.824 2.709" />
            </svg>
          </div>
        </div>

        {/* Error Message */}
        <h1 className="text-3xl sm:text-4xl md:text-5xl font-medium text-gray-900 mb-4 sm:mb-6">
          Page Not Found
        </h1>
        <p className="text-base sm:text-lg md:text-xl text-gray-600 mb-6 sm:mb-8 leading-relaxed">
          Sorry, we couldn't find the page you're looking for. The page might have been moved, deleted, or you entered the wrong URL.
        </p>

        {/* Action Buttons */}
        <div className="flex flex-col sm:flex-row gap-3 sm:gap-4 justify-center mb-8 sm:mb-12">
          <Link 
            to="/" 
            className="bg-brand-blue text-white px-6 sm:px-8 py-2 sm:py-3 rounded-lg font-normal hover:bg-brand-orange transition-all duration-300 text-sm sm:text-base"
          >
            Go Home
          </Link>
          <button 
            onClick={() => window.history.back()} 
            className="bg-white text-brand-blue border-2 border-brand-blue px-6 sm:px-8 py-2 sm:py-3 rounded-lg font-normal hover:bg-brand-blue hover:text-white transition-all duration-300 text-sm sm:text-base"
          >
            Go Back
          </button>
        </div>

        {/* Helpful Links */}
        <div className="border-t border-gray-200 pt-6 sm:pt-8">
          <h3 className="text-lg sm:text-xl font-medium text-gray-900 mb-4 sm:mb-6">
            Popular Pages
          </h3>
          <div className="grid grid-cols-2 sm:grid-cols-3 gap-3 sm:gap-4">
            <Link 
              to="/services" 
              className="text-sm sm:text-base text-gray-600 hover:text-brand-blue transition-colors duration-300"
            >
              Our Services
            </Link>
            <Link 
              to="/portfolio" 
              className="text-sm sm:text-base text-gray-600 hover:text-brand-blue transition-colors duration-300"
            >
              Portfolio
            </Link>
            <Link 
              to="/about" 
              className="text-sm sm:text-base text-gray-600 hover:text-brand-blue transition-colors duration-300"
            >
              About Us
            </Link>
            <Link 
              to="/pricing" 
              className="text-sm sm:text-base text-gray-600 hover:text-brand-blue transition-colors duration-300"
            >
              Pricing
            </Link>
            <Link 
              to="/contact" 
              className="text-sm sm:text-base text-gray-600 hover:text-brand-blue transition-colors duration-300"
            >
              Contact
            </Link>
            <a 
              href="https://wa.me/252618715418" 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-sm sm:text-base text-gray-600 hover:text-brand-blue transition-colors duration-300"
            >
              WhatsApp
            </a>
          </div>
        </div>
      </div>
    </main>
  );
};

export default NotFound;
